// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ComparativoServicos_ListaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /relatorios/comparativo_servicos/lista_comparativo.
 *
 * Returns one row per (servico, categoria) pair with orcamento vs
 * compromisso aggregates, used by the "Comparativo entre serviços" report.
 */
import type { ComparativoServicos_ListaRow } from './ComparativoServicos_ListaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ComparativoServicos_ListaResponseDados = ComparativoServicos_ListaRow[];

export type ComparativoServicos_ListaResponse = ApiResponse<ComparativoServicos_ListaResponseDados>;

registerResponseContract('ComparativoServicos_ListaResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      servico_id:             { type: 'number',  required: true },
      servico_nome:           { type: 'string',  required: true },
      servicoscategoria_id:   { type: 'number',  required: true },
      servicoscategoria_nome: { type: 'string',  required: true },
      qtd_orcamento:          { type: 'string',  required: false },
      total_orcamento:        { type: 'string',  required: false },
      media_orcamento:        { type: 'string',  required: false },
      qtd_compromisso:        { type: 'string',  required: false },
      total_compromisso:      { type: 'string',  required: false },
      media_compromisso:      { type: 'string',  required: false },
    },
  },
})
